(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationAutomationConfDialogController', CommunicationAutomationConfDialogController);

    CommunicationAutomationConfDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', '$window', 'entity',
        'CommunicationAutomationConf', 'ChannelConf', 'Principal', 'AssistantPanelService', '$translate'];

    function CommunicationAutomationConfDialogController($scope, $stateParams, $uibModalInstance, $window, entity,
        CommunicationAutomationConf, ChannelConf, Principal, AssistantPanelService, $translate) {
        var vm = this;
        vm.communicationAutomationConf = entity;
        vm.channels = [];
        vm.showTemplateHelp = false;
        vm.canUseAssistant = false;
        vm.load = function(id) {
            CommunicationAutomationConf.get({id : id}, function(result) {
                vm.communicationAutomationConf = result;
            });
        };

        vm.channelConfs  = ChannelConf.query();
        vm.channels = CommunicationAutomationConf.getChannel();
        vm.save = save;
        vm.clear = clear;
        vm.getSelectedChannelConf = getSelectedChannelConf;
        vm.getSelectedChannel = getSelectedChannel;
        vm.toggleTemplateHelp = toggleTemplateHelp;
        vm.getAvailableVariables = getAvailableVariables;
        vm.previewMessage = previewMessage;
        vm.openAssistantChat = openAssistantChat;

        Principal.identity().then(function(account) {
            if (account) {
                vm.canUseAssistant = (account.modules || []).indexOf('AI_ASSISTANT') !== -1
                    && (account.authorities.indexOf('ROLE_AI_ASSISTANT') !== -1
                    || account.authorities.indexOf('ROLE_ADMIN') !== -1
                    || account.authorities.indexOf('ROLE_SUPER_ADMIN') !== -1);
            }
        });

        function save() {
            vm.isSaving = true;
            if (vm.communicationAutomationConf.id !== null) {
                CommunicationAutomationConf.update(vm.communicationAutomationConf, onSaveSuccess, onSaveError);
            } else {
                CommunicationAutomationConf.save(vm.communicationAutomationConf, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('wamasysApp:communicationAutomationConfUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function clear() {
            AssistantPanelService.close();
            $uibModalInstance.dismiss('cancel');
        }

        function getSelectedChannelConf() {
            if (!vm.communicationAutomationConf.channelConfId || !vm.channelConfs) {
                return null;
            }

            for (var i = 0; i < vm.channelConfs.length; i++) {
                if (vm.channelConfs[i].id === vm.communicationAutomationConf.channelConfId) {
                    return vm.channelConfs[i];
                }
            }
            return null;
        }

        function getSelectedChannel() {
            var channelConf = getSelectedChannelConf();
            return channelConf ? channelConf.channel : null;
        }

        function toggleTemplateHelp() {
            vm.showTemplateHelp = !vm.showTemplateHelp;
        }

        function getAvailableVariables() {
            var commonVariables = [
                '${contractRef}',
                '${contractName}',
                '${contractAddress}',
                '${amountBilled}',
                '${totalToBePaid}',
                '${servicesToBePaid}',
                '${taxesToBePaid}',
                '${servicesToBePaidHtml}',
                '${taxesToBePaidHtml}',
                '${dateNow}',
				'${billingDate}',
				'${billingPeriodStart}',
				'${billingPeriodEnd}'
            ];

            if (vm.communicationAutomationConf.type === 'PAYMENT_RECEIPT') {
                return commonVariables.concat([
                    '${paid}',
                    '${receiptId}',
                    '${paymentDate}'
                ]);
            }

            return commonVariables;
        }

        function previewMessage() {
            CommunicationAutomationConf.preview(vm.communicationAutomationConf).$promise.then(function(preview) {
                if (preview.subject) {
                    openInNewWindow(
                        '<html>' +
                        '<head><title>Subject preview</title></head>' +
                        '<body>' +
                        '<h2>Subject :</h2> ' + preview.subject + ' <hr/>' +
                        '</body>' +
                        '</html>'
                    );
                }

                if (preview.messageHtml) {
                    openInNewWindow(preview.messageHtml);
                }

                if (preview.messageText) {
                    openInNewWindow(
                        '<html>' +
                        '<head><title>Preview</title></head>' +
                        '<body>' +
                        '<textarea rows="10" cols="80">' + preview.messageText + '</textarea>' +
                        '</body>' +
                        '</html>'
                    );
                }
            });
        }

        function openAssistantChat() {
            if (!vm.canUseAssistant) {
                return;
            }

            AssistantPanelService.open({
                contextType: 'COMMUNICATION_TEMPLATE',
                entityId: vm.communicationAutomationConf.id || 0,
                title: $translate.instant('global.assistant.templateTitle'),
                subtitle: vm.communicationAutomationConf.type || 'Communication',
                promptPlaceholder: $translate.instant('global.assistant.templatePromptPlaceholder'),
                supportsActionProposal: false,
                supportsDataScopes: false,
                adapter: {
                    chat: function(payload, success, error) {
                        CommunicationAutomationConf.chatAssistant(buildAssistantRequest(payload), success, error);
                    },
                    getUsage: function(success, error) {
                        CommunicationAutomationConf.getAssistantUsage(success, error);
                    },
                    submitFeedback: function(payload, success, error) {
                        CommunicationAutomationConf.submitAssistantFeedback(payload, success, error);
                    },
                    applyAssistantResponse: function(result) {
                        if (!result || !result.suggestedFieldValues) {
                            return;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template) && result.suggestedFieldValues.template !== null) {
                            vm.communicationAutomationConf.template = result.suggestedFieldValues.template;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template_html) && result.suggestedFieldValues.template_html !== null) {
                            vm.communicationAutomationConf.templateHtml = result.suggestedFieldValues.template_html;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template_subject) && result.suggestedFieldValues.template_subject !== null) {
                            vm.communicationAutomationConf.templateSubject = result.suggestedFieldValues.template_subject;
                        }
                        AssistantPanelService.invalidateConversationContext();
                        $scope.$evalAsync();
                    },
                    buildContextSignatureFragment: function() {
                        return [
                            vm.communicationAutomationConf.type || '',
                            getSelectedChannel() || '',
                            hashString(vm.communicationAutomationConf.template || ''),
                            hashString(vm.communicationAutomationConf.templateHtml || ''),
                            hashString(vm.communicationAutomationConf.templateSubject || '')
                        ].join('|');
                    }
                }
            });
        }

        function buildAssistantRequest(payload) {
            return {
                assistantRequest: payload,
                communicationAutomationConf: angular.copy(vm.communicationAutomationConf),
                selectedChannel: getSelectedChannel(),
                availableVariables: getAvailableVariables(),
                contextType: 'COMMUNICATION_TEMPLATE',
                contextEntityId: vm.communicationAutomationConf.id || null,
                contextLabel: vm.communicationAutomationConf.type || 'Communication',
                contextMetadata: {
                    type: vm.communicationAutomationConf.type,
                    channel: getSelectedChannel()
                }
            };
        }

        function hashString(value) {
            var stringValue = value || '';
            var hash = 0;
            var i;
            var chr;
            for (i = 0; i < stringValue.length; i++) {
                chr = stringValue.charCodeAt(i);
                hash = ((hash << 5) - hash) + chr;
                hash |= 0;
            }
            return hash;
        }

        function openInNewWindow(content) {
            var newWindow = $window.open('', '_blank');

            newWindow.document.open();
            newWindow.document.write(content);
            newWindow.document.close();
        }
    }
})();
